import React, { useState, useRef, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Footer from "../shared/Footer";
import Navbar from "../shared/Navbar";
import Sidebar from "../shared/Sidebar";
import Swal from "sweetalert2";
import config from "../../config";
function Dashboard() {
    const navigate = useNavigate();
    const token = sessionStorage.getItem("secondaryAdminToken");
    const [loading, setLoading] = useState(true);
    const [dashboardData, setDashboardData] = useState({});

    const fetchDashboardData = async () => {
        setLoading(true);
        try {
            const response = await fetch(
                `${config.API_BASE_URL}/AdminDashBoardCountSecondary`,
                {
                    method: "GET",
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                }
            );

            const data = await response.json();
            console.log("Response:", data);
            if (response.ok) {
                setDashboardData(data.data.admindashboard_secondary || {});
            } else {
                Swal.fire("Error", data?.message || "Unable to fetch data", "error");
            }
        } catch (error) {
            Swal.fire("Error", "Something went wrong. Try again later.", "error");
            console.error("Fetch error:", error);
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        if (!token) {
            navigate("/secondary-admin");
        } else {
            fetchDashboardData();
        }
    }, [navigate]);
    return (
        <>
            <div className="container-scroller">
                <Navbar />
                {loading && (
                    <div className="custom-loader-container">
                        <div className="custom-loader"></div>
                    </div>
                )}
                <div className="container-fluid page-body-wrapper">
                    <Sidebar />
                    <div className="main-panel">
                        <div className="content-wrapper">
                            <div className="row">
                                <div className="col-md-12 mb-3">
                                    <div className="row">
                                        <div className="col-12 col-xl-12 mb-4 mb-xl-0">
                                            <h3 className="font-weight-bold" style={{ textTransform: 'uppercase' }}>
                                                Welcome Admin
                                            </h3>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="row">

                                {/* Total Payments - Pending for Verification */}
                                <div className="col-md-3 col-xl-3 mb-4 stretch-card transparent">
                                    <a href="#" className="card card-dark-blue" style={{ textDecoration: 'none' }} onClick={(e) => { e.preventDefault(); navigate("/secondary-admin-school-list"); }}>
                                        <div className="card-body">
                                            <div className="row">
                                                <div className="col-md-9">
                                                    <h3 className="mb-2">
                                                        Total School <br />
                                                        {/* <small className="card-text">Pending for Verification</small> */}
                                                    </h3>
                                                    <p className="fs-30 mb-2 mt-4">
                                                        {dashboardData.schooL_COUNT_SECONDARY || 0}
                                                    </p>
                                                </div>
                                                <div className="col-md-3" style={{ textAlign: 'center' }}>
                                                    <i className="fa fa-university icon-large" style={{ fontSize: 40 }} />
                                                </div>
                                            </div>
                                        </div>
                                    </a>
                                </div>

                            </div>
                        </div>
                        <Footer />
                    </div>
                </div>
            </div>
        </>
    );
}

export default Dashboard;
